import type { AssetsBatchEditAssetTypeAlertProps } from "./assets-batch-edit-asset-type-alert.type";

import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import { FormItemAlert } from "@/ui/form-item-alert";

import "./assets-batch-edit-asset-type-alert.style.less";

const { Text } = Typography;

export const AssetsBatchEditAssetTypeAlert = ({
  assets = [],
  concernedAssets = [],
}: AssetsBatchEditAssetTypeAlertProps) => {
  const { t } = useTranslation();

  const allConcerned = assets.length === concernedAssets.length;

  return (
    <FormItemAlert
      title={
        <div>
          <Text>{t("asset:batchEdit.assetType.alert")}</Text>
          <Text>
            <strong>{t("asset:batchEdit.assetType.concernedAssets")}</strong>
            {allConcerned && " " + t("asset:batchEdit.assetType.all")}
          </Text>
          {!allConcerned && (
            <ul>
              {concernedAssets.map((asset) => (
                <li key={asset.id}>
                  <Text ellipsis>{asset.name}</Text>
                </li>
              ))}
            </ul>
          )}
        </div>
      }
      className="assets-batch-edit-asset-type-alert"
    />
  );
};
